import subModuleKeys from '@/modules/constants/subModuleKeys';

const SalesReportsModule = () => import(/* webpackChunkName: "salesreports" */ '@/components/modules/reports/sales-reports/SalesReportsModule.vue');
const ManagementReportsModule = () => import(/* webpackChunkName: "managementreports" */ '@/components/modules/reports/management/ManagementReportsModule.vue');
const GuestListModule = () => import(/* webpackChunkName: "guestlist" */ '@/components/modules/reports/guest-list/GuestListModule.vue');
const SubscriptionsModule = () => import(/* webpackChunkName: "subscriptions" */ '@/components/modules/reports/SubscriptionsModule.vue');
const TailoredReportsModule = () => import(/* webpackChunkName: "tailoredreports" */ '@/components/modules/reports/TailoredReportsModule.vue');
const ReportsDashboardModule = () => import(/* webpackChunkName: "reportsdashboard" */ '@/components/modules/reports/salestrend/SalesTrendModule.vue');

const subModules = {
  [subModuleKeys.SALES_REPORTS]: {
    name: subModuleKeys.SALES_REPORTS,
    component: SalesReportsModule,
    path: '/reports/sales',
    props: { moduleKey: subModuleKeys.SALES_REPORTS },
  },
  [subModuleKeys.MANAGEMENT_REPORTS]: {
    name: subModuleKeys.MANAGEMENT_REPORTS,
    component: ManagementReportsModule,
    path: '/reports/management',
    props: { moduleKey: subModuleKeys.MANAGEMENT_REPORTS },
  },
  [subModuleKeys.GUEST_LIST]: {
    name: subModuleKeys.GUEST_LIST,
    component: GuestListModule,
    path: '/reports/guestlist',
    props: { moduleKey: subModuleKeys.GUEST_LIST },
  },
  [subModuleKeys.TAILORED_REPORTS]: {
    name: subModuleKeys.TAILORED_REPORTS,
    component: TailoredReportsModule,
    path: '/reports/tailored',
    props: { moduleKey: subModuleKeys.TAILORED_REPORTS },
  },
  [subModuleKeys.SUBSCRIPTIONS]: {
    name: subModuleKeys.SUBSCRIPTIONS,
    component: SubscriptionsModule,
    path: '/reports/subscriptions',
    props: { moduleKey: subModuleKeys.SUBSCRIPTIONS },
  },
  [subModuleKeys.SALES_TREND]: {
    name: subModuleKeys.SALES_TREND,
    component: ReportsDashboardModule,
    path: '/reports/salestrend',
    props: { moduleKey: subModuleKeys.SALES_TREND },
  },
};

export default subModules;
